import en from './en.js'
import es from './es.js'
import fr from './fr.js'
import de from './de.js'
import it from './it.js'

const locales = {
  en,
  es,
  fr,
  de,
  it
};
export default locales;



// WEBPACK FOOTER //
// ./src/locales/index.js